import _ from 'lodash'

export default function getBannerName(
  filters,
) {
  const department = _.get(filters, 'departmentCodeEq')
  const categorty = _.get(filters, 'categoryCodeEq')
  const brands = _.castArray(_.get(filters, 'brandCodeEq', []))
  switch (true) {
    case !_.isEmpty(department) && !_.isEmpty(categorty):
      return `ecom_plp_banner_${department}_${categorty}`

    case !_.isEmpty(department):
      return `ecom_plp_banner_${department}`

    case !_.isEmpty(categorty):
      return `ecom_plp_banner_${categorty}`

    case _.size(brands) === 1:
      return `ecom_plp_banner_brand_${_.first(brands)}`

    default:
      return 'ecom_plp_banner_all'
  }
}
